export const BLOG_URL = "/";

export const BLOG_SITE_URL = "https://mounirahmed.dev";

export const BLOG_NAME = "MounirTech";

export const BLOG_TAGLINE = "Build. Learn. Ship.";

export const BLOG_DESCRIPTION =
  "Practical writing on frontend development, career growth, product reviews, fintech, and productivity — by Mounir Ahmed.";

export const PORTFOLIO_URL = "/portfolio";

export const blogNavLinks = [
  { href: "/", label: "Home" },
  { href: "/posts", label: "Posts" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
];

export const FALLBACK_CATEGORIES = [
  {
    slug: "frontend",
    name: "Frontend",
    description: "React, CSS, architecture, and modern web development.",
    sort_order: 1,
  },
  {
    slug: "career",
    name: "Career",
    description: "CVs, jobs, freelancing, and professional growth.",
    sort_order: 2,
  },
  {
    slug: "reviews",
    name: "Reviews",
    description: "Hands-on product and tool reviews.",
    sort_order: 3,
  },
  {
    slug: "fintech",
    name: "Fintech",
    description: "Payments, virtual cards, and withdrawals.",
    sort_order: 4,
  },
  {
    slug: "productivity",
    name: "Productivity",
    description: "Tools, extensions, and workflows that save time.",
    sort_order: 5,
  },
] as const;

export const navLinks = [
  { href: PORTFOLIO_URL, label: "Home" },
  { href: `${PORTFOLIO_URL}/about`, label: "About" },
  { href: `${PORTFOLIO_URL}/projects`, label: "Projects" },
  { href: BLOG_URL, label: "Blog", external: false },
  { href: `${PORTFOLIO_URL}/contact`, label: "Contact" },
];
